import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-comprobante-if',
  templateUrl: './comprobante-if.component.html',
  styleUrls: ['./comprobante-if.component.scss']
})
export class ComprobanteIfComponent{

  constructor(private loginService: LoginService) { }


  clickGuard() {
    this.loginService.clickGuard = true;
  }

}
